<template>
  <div :class="['import-map-ui', isDisabled && 'import-map-ui--disabled']">
    <VCard class="flat">
      <div class="import-map-ui__content">
        <div class="import-map-ui__title">
          <VHeading :level="3" class="map-config">Mapping configuration</VHeading>
        </div>
        <div class="import-map-ui__mode-btn">
          <VBtn class="link" flat :disabled="isDisabled" @click="toggleMode">
            <span class="import-map-ui__mode-btn-icon">
              <SwitchIcon />
            </span>
            <span>{{ btnTitle }}</span></VBtn
          >
        </div>
        <ImportMapSave
          v-if="isManaging"
          :company-id="companyId"
          :header-indexes="headerIndexes"
          :variant="variant"
          :source-type="sourceType"
          :selected-source-id="selectedSourceId"
          :selected-source-name="selectedSourceName"
          :is-disabled="isDisabled"
        />
        <ImportMapSelect
          v-else
          :company-id="companyId"
          :selected-map="selectedMap"
          :header-indexes="headerIndexes"
          :is-disabled="isDisabled"
          @on-select="emitSelect"
        />
      </div>
    </VCard>
  </div>
</template>

<script lang="ts" setup>
  // Types
  import type { EMappingVariant, ESourceType, TImportColumnIndexes } from '~/shared/import/types';
  import type { TImportMap } from '~/shared/import/map/types';

  // Components
  import VBtn from '~/misc/v-btn';
  import ImportMapSave from '~/shared/import/map/save/ImportMapSave.vue';
  import ImportMapSelect from '~/shared/import/map/select/ImportMapSelect.vue';
  import VCard from '~/misc/v-card';
  import VHeading from '~/misc/v-heading/VHeading.vue';
  import SwitchIcon from '~/misc/icons/switch/SwitchIcon.vue';

  defineProps({
    companyId: {
      type: Number,
      required: true,
    },
    selectedMap: {
      type: Object as PropType<TImportMap | null>,
      default: null,
    },
    headerIndexes: {
      type: Object as PropType<TImportColumnIndexes>,
      required: true,
    },
    variant: {
      type: String as PropType<EMappingVariant>,
      required: true,
    },
    sourceType: {
      type: String as PropType<ESourceType>,
      required: true,
    },
    selectedSourceId: {
      type: Number as PropType<number | null>,
      default: null,
    },
    selectedSourceName: {
      type: String as PropType<string | null>,
      default: null,
    },
    isDisabled: {
      type: Boolean,
      required: false,
    },
  });

  const emit = defineEmits<{
    (e: 'on-select', map: TImportMap | undefined): void;
  }>();

  const isManaging: Ref<boolean> = ref<boolean>(false);

  const btnTitle: ComputedRef<string> = computed<string>(() =>
    isManaging.value ? 'Choose existing' : 'Create new'
  );

  const setIsManaging = (state: boolean) => {
    isManaging.value = state;
  };

  const toggleMode = () => setIsManaging(!isManaging.value);

  const emitSelect = (map: TImportMap | undefined) => {
    emit('on-select', map);
  };
</script>
